<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size: 15px; font-weight: bold">Account type</small>
      </legend>
      <div>
        <form @submit.prevent="newAccount()">
          <div class="form-group">
            <label>Account name</label>
            <input
              type="text"
              class="form-control account_name input-rounded f-s-14"
              placeholder="accounttype name"
              required
            />
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingAccounttype btn-rounded">
            <i class="fa fa-plus"></i> create Account type
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat creatingAccounttypeLoader btn-rounded"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["newAccount"])
  }
};
</script>
<style scoped>
.creatingAccounttypeLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/accounttypes/accounttype.vue